import { createSelector } from 'reselect'

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getId = (state, props) => {
  return props.id
}

export const getAlarmIds = (state, props) => {
  return state.kanbo.alarms.ids
}

export const getAlarmsById = (state, props) => {
  return state.kanbo.alarms.byId
}

export const alarmsSelector = createSelector(
  [getId, getAlarmIds, getAlarmsById],
  (id, alarmIds, alarmsById) =>
    alarmIds
      .map(id => alarmsById[id])
      .filter(alarm => alarm.eventId === id && !alarm.isDefault)
      .sort((a, b) => a.timestamp - b.timestamp)
)

export default createSelector(
  [
    getIsArchived,
    alarmsSelector
  ],
  (
    isArchived,
    alarms
  ) => ({
    isArchived,
    alarms
  })
)
